let pageUnloading = false;

if (typeof window !== "undefined") {
  // "pagehide" is the reliable teardown signal on mobile browsers
  // (beforeunload is unreliable there and breaks bfcache). The "pageshow"
  // reset is load-bearing: a page restored from bfcache comes back alive with
  // module state intact, and without the reset it would permanently suppress
  // unload-aware error reporting for the rest of the session.
  window.addEventListener("pagehide", () => {
    pageUnloading = true;
  });
  window.addEventListener("pageshow", () => {
    pageUnloading = false;
  });
}

export function isPageUnloading(): boolean {
  return pageUnloading;
}
